import React from 'react';
export function Chapter6() {
  return <section className="py-8 border-t border-gray-200" data-id="element-170">
      <h2 className="text-2xl font-bold mb-6" data-id="element-171">
        De små segrarna som ingen ser – utom du
      </h2>
      <p className="mb-4 text-lg" data-id="element-172">
        Det är inte en scen i slow motion med applåd. Det är vardagens nästan
        osynliga vinster:
      </p>
      <ul className="list-disc pl-8 mb-6 space-y-2 text-lg" data-id="element-173">
        <li data-id="element-174">
          Jag står i mataffären med en mental lista och kommer hem med{' '}
          <span className="font-semibold" data-id="element-175">allt</span> – inte bara hälften.
        </li>
        <li data-id="element-176">
          Jag läser sista kapitlet i boken och{' '}
          <span className="font-semibold" data-id="element-177">minns</span> vad som hände i det
          första – utan att behöva bläddra tillbaka.
        </li>
        <li data-id="element-178">
          Jag hittar ord mitt i samtalet utan att stanna upp vid kanten –{' '}
          <span className="font-semibold" data-id="element-179">som om de aldrig varit borta</span>.
        </li>
        <li data-id="element-180">
          Jag{' '}
          <span className="font-semibold" data-id="element-181">slipper känna den tysta paniken</span>{' '}
          när någon frågar "kommer du ihåg när vi..." och mitt sinne är tomt.
        </li>
      </ul>
      <p className="mb-4 text-lg" data-id="element-182">
        En lördag bakade jag kanelbullar med mitt barnbarn. Tidigare brukade jag
        förlägga halva receptet mellan "knåda" och "låt jäsa". Den här gången
        följde jag tråd efter tråd. Inga genvägar. Inget tapp. Bara vi två och
        deg som blev till bullar.
      </p>
      <blockquote className="border-l-4 border-[#2e7d32] pl-4 italic my-6 text-lg" data-id="element-183">
        "Det handlar inte om att bli 25 igen – utan om att{' '}
        <span className="not-italic font-semibold" data-id="element-184">
          känna sig hemma i sitt eget huvud
        </span>
        . Att slippa fruktan för vad du ska glömma härnäst."
      </blockquote>
      <p className="mb-4 text-lg" data-id="element-185">
        Efter åtta veckor slutade jag i tre dagar. Det är säkert mest
        inbillning, sa jag till mig själv. Dag ett: ingen skillnad. Dag två:
        inte heller. Dag tre: jag stod vid köksbänken och fumlade efter
        receptets nästa steg, som om någon stängt en kran i bakhuvudet. Det var
        inte ett ras – bara en vaggning åt fel håll. Jag återgick. Inte av
        rädsla. Av respekt för den där stilla stabiliteten.
      </p>
      <div className="mt-6 mb-6" data-id="element-186">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rTNnjxu4FKPQpPuZngBG9n/93fb2673-20be-4d52-831d-c7c2e6c180de_min.webp" alt="Äldre kvinna med silvervitt hår i vit kofta som skrattar med vänner utomhus" className="w-full h-auto rounded-lg shadow-md object-cover" style={{
        height: '400px'
      }} width="1200" height="400" data-id="element-187" />
      </div>
      <div className="bg-gray-100 p-5 rounded-lg border-l-4 border-[#2e7d32] shadow-sm" data-id="element-188">
        <p className="text-lg font-medium mb-2" data-id="element-189">Tänk på det såhär:</p>
        <p className="mb-3" data-id="element-190">
          Varje gång du glömmer något, varje gång du tappar tråden, varje gång
          du ser den där blicken från någon du älskar –{' '}
          <span className="font-semibold" data-id="element-191">
            det är en liten bit av din självständighet som eroderar
          </span>
          . Det är inte dramatiskt. Det är subtilt. Men över tid blir det en
          identitet: den som behöver hjälp, den som inte kan lita på sitt eget
          minne.
        </p>
        <p data-id="element-192">
          Frågan är inte om du har råd att prova något nytt. Frågan är om du har
          råd att <span className="italic" data-id="element-193">inte</span> göra det.
        </p>
      </div>
    </section>;
}